import { useEffect, useState } from "react";
import man from '../public/assets/images/man.svg'
export default function ManImg() {
    const [deviceSize, setDeviceSize] = useState('m');

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isLDevice: MediaQueryList = window.matchMedia("(max-width: 1440px)");
            const isMDevice: MediaQueryList = window.matchMedia("(max-width: 1024px)");
            const isSDevice: MediaQueryList = window.matchMedia("(max-width: 768px)");
            if (isSDevice.matches) {
                setDeviceSize('s')
            } else if (isMDevice.matches) {
                setDeviceSize('m')
            } else if (isLDevice.matches) {
                setDeviceSize('l')
            }
        }
    }, [deviceSize]);

    return (
        <img className="header-logo" src={man} alt="success" width={deviceSize === 'l' ? 431 : deviceSize === 'm' ? 383 : 287} height={deviceSize === 'l' ? 364 : deviceSize === 'm' ? 324 : 287} />
    )
}
